<template>
  <div class="container-troop">
    <!-- 头部 -->
    <home-header></home-header>
    <!-- banner -->
    <div class="banner-info"></div>
    <!-- 菜单栏 -->
    <div class="menu">
      <mt-navbar v-model="selected" style="display: none">
<!--        <mt-tab-item id="1">国外部分导师</mt-tab-item>-->
        <mt-tab-item id="2" >国内部分导师</mt-tab-item>
      </mt-navbar>
      <mt-tab-container v-model="selected">
<!--        <mt-tab-container-item id="1">-->
<!--          <div class="right-wapper">-->
<!--            <div class="teacher-wrapper">-->
<!--              <img src="../assets/images/jean.png"/>-->
<!--            </div>-->
<!--            <div class="teacher-text">-->
<!--              <h3>Jean MOUSSAVOU</h3>-->
<!--              <p>法国著名的金融学教授，巴黎第九大学（巴黎多芬大学）管理学博士</p>-->
<!--              <p>现任职于法国布雷斯特高等商学院</p>-->
<!--              <p>同时兼任法国西布列塔尼大学博士生导师</p>-->
<!--            </div>-->
<!--            <div style="clear: both;"></div>-->
<!--          </div>-->
<!--          <div class="right-wapper">-->
<!--            <div class="teacher-wrapper">-->
<!--              <img src="../assets/images/teacher/dl.png"/>-->
<!--            </div>-->
<!--            <div class="teacher-text">-->
<!--              <h3>DAVID LELOUVIER</h3>-->
<!--              <p>企业家、CEO</p>-->
<!--              <p>ASHRIDGE高等商学院MBA</p>-->
<!--              <p>历任飞利浦半导体法国分公司工业部门经理</p>-->
<!--            </div>-->
<!--            <div style="clear: both;"></div>-->
<!--          </div>-->
<!--          <div class="right-wapper">-->
<!--            <div class="teacher-wrapper">-->
<!--              <img src="../assets/images/teacher/md.png"/>-->
<!--            </div>-->
<!--            <div class="teacher-text">-->
<!--              <h3>MICHEL DUQUETTE</h3>-->
<!--              <p>国际采购高级执行官</p>-->
<!--              <p>毕业于INSEAD欧洲工商管理学院</p>-->
<!--              <p>历任采购与供应商高级总监，GE石油与天然气（美国）全球供应链副总裁</p>-->
<!--            </div>-->
<!--            <div style="clear: both;"></div>-->
<!--          </div>-->
<!--          <div class="right-wapper">-->
<!--            <div class="teacher-wrapper">-->
<!--              <img src="../assets/images/teacher/pd.png"/>-->
<!--            </div>-->
<!--            <div class="teacher-text">-->
<!--              <h3>Pierre DELORT</h3>-->
<!--              <p>首席知识官CIO、首席执行官COO博士</p>-->
<!--              <p>巴黎高商与巴黎高等矿业学校客座教授</p>-->
<!--              <p>历任GENERALI保险集团企业副总裁</p>-->
<!--            </div>-->
<!--            <div style="clear: both;"></div>-->
<!--          </div>-->
<!--          <div class="right-wapper">-->
<!--            <div class="teacher-wrapper">-->
<!--              <img src="../assets/images/teacher/rq.png"/>-->
<!--            </div>-->
<!--            <div class="teacher-text">-->
<!--              <h3>Robert de QUELEN</h3>-->
<!--              <p>资深管理咨询师，25年行业经验</p>-->
<!--              <p>曾在多所知名公关公司担任重要职务，如凯维公关（Cohn & Wolfe）罗德公关（Ruder Finn）、爱德曼集团（EDELMAN）等</p>-->
<!--            </div>-->
<!--            <div style="clear: both;"></div>-->
<!--          </div>-->
<!--        </mt-tab-container-item>-->
        <mt-tab-container-item id="2">
          <div class="right-wapper">
            <div class="teacher-wrapper">
              <img src="../assets/images/zys.png"/>
            </div>
            <div class="teacher-text">
              <h3>张燕生</h3>
              <p>国家发展与改革委员会学术委员会秘书长</p>
              <p>享受国务院政府特殊津贴专家</p>
            </div>
          </div>
          <div style="clear: both;"></div>
          <div class="right-wapper">
            <div class="teacher-wrapper">
              <img src="../assets/images/teacher/yjl.png"/>
            </div>
            <div class="teacher-text">
              <h3>郁俊莉</h3>
              <p>理学博士</p>
              <p>现任北京大学教授、博士生导师，北京大学中国新兴产业创新研究中心主任，广东省发展和改革委员会学术委员会委员，国家区域发展战略和新兴产业研究专家，教育部新世纪优秀人才</p>
            </div>
          </div>
          <div style="clear: both;"></div>
          <div class="right-wapper">
            <div class="teacher-wrapper">
              <img src="../assets/images/teacher/zy.png"/>
            </div>
            <div class="teacher-text">
              <h3>张延</h3>
              <p>
                北京大学经济学院教授，宏观经济学专业博士生导师，北京大学精品课程主讲人，国内外数十所著名高校DBA授课专家，在北京大学经济学院分别获得了经济学学士学位、国际金融硕士学位、西方经济学博士学位</p>
            </div>
          </div>
          <div style="clear: both;"></div>
          <div class="right-wapper">
            <div class="teacher-wrapper">
              <img src="../assets/images/teacher/xx.png"/>
            </div>
            <div class="teacher-text">
              <h3>薛旭</h3>
              <p>
                北京大学经济学院教授、企业战略管理课程的首创者，北大IIE国际营销与品牌战略研究中心主任，中国市场学会营销专家委员会秘书长，著名战略管理与营销管理专家，著名跨国公司在华投资企业的战略和营销顾问</p>
            </div>
          </div>
          <div style="clear: both;"></div>
          <div class="right-wapper">
            <div class="teacher-wrapper">
              <img src="../assets/images/teacher/fk.png"/>
            </div>
            <div class="teacher-text">
              <h3>冯科</h3>
              <p>北京大学经济学院金融系博士生导师，北京大学金融与产业发展研究中心主任，北大资产经营有限公司董事，国家互联网金融安全技术专家委员会委员，新经济杂志副主编</p>
            </div>
          </div>
          <div style="clear: both;"></div>
          <div class="right-wapper">
            <div class="teacher-wrapper">
              <img src="../assets/images/teacher/lcq.png"/>
            </div>
            <div class="teacher-text">
              <h3>路长全</h3>
              <p>营销战略与品牌运营专家，“切割大营销”理论的创始人，中国营销泰斗，北京大学民营经济营销课题组组长，中国资本市场研究院学术委员会委员，中央电视台广告部策略顾问</p>
            </div>
          </div>
          <div style="clear: both;"></div>
          <div class="right-wapper">
            <div class="teacher-wrapper">
              <img src="../assets/images/teacher/zws.png"/>
            </div>
            <div class="teacher-text">
              <h3>周旺生</h3>
              <p>北京大学教授（A1级），国家重点学科法学理论专业博士生导师，北京大学立法学研究中心主任，《立法研究》主编，兼任中国法理学会副会长，中国立法学会副会长</p>
            </div>
          </div>
          <div style="clear: both;"></div>
          <div class="right-wapper">
            <div class="teacher-wrapper">
              <img src="../assets/images/teacher/cdm.png"/>
            </div>
            <div class="teacher-text">
              <h3>陈东敏</h3>
              <p>北京大学前沿交叉学科研究院、大数据研究院讲席教授、博士生导师，北京大学千人引进学者，北京大学中国新兴产业创新研究中心联席主任，广东省松山湖材料实验室常务副主任</p>
            </div>
          </div>
          <div style="clear: both;"></div>
          <div class="right-wapper">
            <div class="teacher-wrapper">
              <img src="../assets/images/teacher/wc.png"/>
            </div>
            <div class="teacher-text">
              <h3>王超</h3>
              <p>北京大学国家发展研究院教授，清华大学公益慈善研究院资深研究员，曾任清华大学公益慈善研究院执行院长。《中国非营利评论》编委，《中国大百科全书》非营利组织管理部副主编，清华-MIT
                IDEAS领导力计划首席教授</p>
            </div>
          </div>
          <div style="clear: both;"></div>
          <div class="right-wapper">
            <div class="teacher-wrapper">
              <img src="../assets/images/teacher/lbf.png"/>
            </div>
            <div class="teacher-text">
              <h3>吕本富</h3>
              <p>中国科学院大学经管学院教授、博士生导师， 中国科学院大学网络经济和知识管理研究中心主任，国家创新与发展战略研究会副理事长兼创新驱动研究院院长，网络经济专家</p>
            </div>
          </div>
          <div style="clear: both;"></div>
          <div class="right-wapper">
            <div class="teacher-wrapper">
              <img src="../assets/images/teacher/jzx.png"/>
            </div>
            <div class="teacher-text">
              <h3>姜正新</h3>
              <p>工商管理硕士、经济学博士、教授，曾任职中国联通集团有限公司副总经理，党组成员，现任法国布雷斯特高等商学院中国区总负责人，伟东云教育集团副董事长</p>
            </div>
          </div>
          <div style="clear: both;"></div>
          <div class="right-wapper">
            <div class="teacher-wrapper">
              <img src="../assets/images/teacher/liuleyuan.png"/>
            </div>
            <div class="teacher-text">
              <h3>刘乐元</h3>
              <p>华中科技大学人工智能与自动化学院博士</p>
              <p>华中师范大学教育大数据应用技术国家工程实验室副教授</p>
            </div>
          </div>
          <div style="clear: both;"></div>
          <div class="right-wapper">
            <div class="teacher-wrapper">
              <img src="../assets/images/teacher/teacher04.png"/>
            </div>
            <div class="teacher-text">
              <h3>张晨宇</h3>
              <p>北京理工大学管理与经济学院管理科学与工程博士</p>
            </div>
            <div style="clear: both;"></div>
          </div>
          <div class="right-wapper">
            <div class="teacher-wrapper">
              <img src="../assets/images/teacher/teacher01.png"/>
            </div>
            <div class="teacher-text">
              <h3>熊伟</h3>
              <p>对外经贸大学国际商学院营销学系主任</p>
              <p>全球研究中心副主任，管理学博士</p>
            </div>
            <div style="clear: both;"></div>
          </div>
          <div class="right-wapper">
            <div class="teacher-wrapper">
              <img src="../assets/images/teacher/wangzhan.png"/>
            </div>
            <div class="teacher-text">
              <h3>王真</h3>
              <p>中石油大学（北京）克拉玛依校区教授</p>
              <p>北京工商大学商学院教授</p>
              <p>曾任北京工商大学MBA教育</p>
            </div>
            <div style="clear: both;"></div>
          </div>
          <div class="right-wapper">
            <div class="teacher-wrapper">
              <img src="../assets/images/teacher/teacher02.png"/>
            </div>
            <div class="teacher-text">
              <h3>王汉生</h3>
              <p>北京大学光华管理学院商务统计与经济计量系系主任教授，博士生导师</p>
              <p>现兼任北京大学商务智能研究中心主任</p>
            </div>
            <div style="clear: both;"></div>
          </div>
          <div class="right-wapper">
            <div class="teacher-wrapper">
              <img src="../assets/images/teacher/teacher03.png"/>
            </div>
            <div class="teacher-text">
              <h3>何辉</h3>
              <p>北京工商大学商学院副教授，硕士研究生导师</p>
              <p>一直从事人力资源开发、组织行为、绩效管理和创新管理等领域的教学与研究工作</p>
            </div>
            <div style="clear: both;"></div>
          </div>
          <div class="right-wapper">
            <div class="teacher-wrapper">
              <img src="../assets/images/teacher/zhangzhiyong.png"/>
            </div>
            <div class="teacher-text">
              <h3>张智勇</h3>
              <p>北京大学心理学副教授</p>
              <p>北京社会心理雪会理事 、副秘书长</p>
            </div>
          </div>
          <div style="clear: both;"></div>
          <div class="right-wapper">
            <div class="teacher-wrapper">
              <img src="../assets/images/teacher/zys.png"/>
            </div>
            <div class="teacher-text">
              <h3>张燕生</h3>
              <p>国家发展与改革委员会学术委员会秘书长</p>
              <p>享受国务院政府特殊津贴专家</p>
            </div>
          </div>
          <div style="clear: both;"></div>
          <div class="right-wapper">
            <div class="teacher-wrapper">
              <img src="../assets/images/teacher/shihaitao.png"/>
            </div>
            <div class="teacher-text">
              <h3>史海涛</h3>
              <p>广州市魔范电子商务有限公司高级副总裁</p>
              <p>前采邑科技CEO</p>
              <p>前启明乐投资产管理有限公司董事副总裁</p>
              <p>前星游娱乐传有限公司COO</p>
            </div>
          </div>
          <div style="clear: both;"></div>
          <div class="right-wapper">
            <div class="teacher-wrapper">
              <img src="../assets/images/teacher/wangpeipei.png"/>
            </div>
            <div class="teacher-text">
              <h3>王培培</h3>
              <p>北京语言大学外国语言学及应用语言学硕士</p>
              <p>蒙彼利埃高等商学院国际商务管理硕士</p>
            </div>
          </div>
          <div style="clear: both;"></div>
          <div class="right-wapper">
            <div class="teacher-wrapper">
              <img src="../assets/images/teacher/zhanglu.png"/>
            </div>
            <div class="teacher-text">
              <h3>张路</h3>
              <p>北京工商大学商学院会计系硕士生导师</p>
              <p>美国注册金融分析师，财务部高端会计人才</p>
            </div>
          </div>
          <div style="clear: both;"></div>
          <div class="right-wapper">
            <div class="teacher-wrapper">
              <img src="../assets/images/teacher/zhangyong.png"/>
            </div>
            <div class="teacher-text">
              <h3>张勇</h3>
              <p>北京大学博士，南开大学国际法法学研究所所长</p>
              <p>天津仲裁委员会涉外仲裁员，天津市人民政府法律顾问</p>
            </div>
          </div>
          <div style="clear: both;"></div>
          <div class="right-wapper">
            <div class="teacher-wrapper">
              <img src="../assets/images/teacher/tianpeng.png"/>
            </div>
            <div class="teacher-text">
              <h3>田鹏</h3>
              <p>海纳易学特聘讲师</p>
              <p>华中师范大学公共管理学院教授</p>
            </div>
          </div>
          <div style="clear: both;"></div>
          <div class="right-wapper">
            <div class="teacher-wrapper">
              <img src="../assets/images/teacher/wubaopei.png"/>
            </div>
            <div class="teacher-text">
              <h3>吴宝沛</h3>
              <p>香港中文大学教育心理学博士</p>
              <p>北京林业大学副教授</p>
            </div>
          </div>
          <div style="clear: both;"></div>
          <div class="right-wapper">
            <div class="teacher-wrapper">
              <img src="../assets/images/teacher/yanghaoxiong.png"/>
            </div>
            <div class="teacher-text">
              <h3>杨浩雄</h3>
              <p>海纳易学特聘讲师</p>
              <p>北京工商大学商学院、副院长</p>
            </div>
          </div>
          <div style="clear: both;"></div>
          <div class="right-wapper">
            <div class="teacher-wrapper">
              <img src="../assets/images/teacher/zhangpeng.png"/>
            </div>
            <div class="teacher-text">
              <h3>张鹏</h3>
              <p>财政部政策实验室宏观经济部主任</p>
              <p>经济学博士 ，财政部多项财政改革的关键研究人员</p>
              <p>中国社科院宏观经济运行与财政政策研究组主要负责人</p>
            </div>
          </div>
          <div style="clear: both;"></div>
          <div class="right-wapper">
            <div class="teacher-wrapper">
              <img src="../assets/images/teacher/cuili.png"/>
            </div>
            <div class="teacher-text">
              <h3>崔丽</h3>
              <p>海纳易学商学院特聘讲师</p>
              <p>北京工商大学商学院物流管理系管理科学专业副教授、硕士生导师</p>
            </div>
          </div>
          <div style="clear: both;"></div>
          <div class="right-wapper">
            <div class="teacher-wrapper">
              <img src="../assets/images/teacher/guanyurong.png"/>
            </div>
            <div class="teacher-text">
              <h3>管玉荣</h3>
              <p>中央民族大学外国语学院法语教师 </p>
              <p>法国里昂三大访问学者</p>
            </div>
          </div>
          <div style="clear: both;"></div>
          <div class="right-wapper">
            <div class="teacher-wrapper">
              <img src="../assets/images/teacher/jincancan.png"/>
            </div>
            <div class="teacher-text">
              <h3>金灿灿</h3>
              <p>北京师范大学教育学博士中国心理学会康复心理委员会（筹）副主任委员 </p>
              <p>中国社会心理学会生态与环境心理学专业委员会委员</p>
            </div>
          </div>
          <div style="clear: both;"></div>
          <div class="right-wapper">
            <div class="teacher-wrapper">
              <img src="../assets/images/teacher/zhangshuojun.png"/>
            </div>
            <div class="teacher-text">
              <h3>张砾匀</h3>
              <p>清华、北大总裁办讲师北京医师协会全科医学专家委员 </p>
              <p>国家二级心理咨询师</p>
            </div>
          </div>
          <div style="clear: both;"></div>
          <div class="right-wapper">
            <div class="teacher-wrapper">
              <img src="../assets/images/teacher/yinwengang.png"/>
            </div>
            <div class="teacher-text">
              <h3>尹文刚</h3>
              <p>中国科学院心理研究所研究员</p>
            </div>
          </div>
          <div style="clear: both;"></div>
          <div class="right-wapper">
            <div class="teacher-wrapper">
              <img src="../assets/images/teacher/lihong.png"/>
            </div>
            <div class="teacher-text">
              <h3>李虹</h3>
              <p>心理学教授</p>
              <p>中国教育台客座教授</p>
              <p>贝索企业管理咨询有限公司董事长</p>
            </div>
          </div>
          <div style="clear: both;"></div>
          <div class="right-wapper">
            <div class="teacher-wrapper">
              <img src="../assets/images/teacher/wangweihua.png"/>
            </div>
            <div class="teacher-text">
              <h3>王薇华</h3>
              <p>中国地质大学博士</p>
              <p>积极心理学专家</p>
              <p>首席幸福力导师</p>
            </div>
          </div>
          <div style="clear: both;"></div>
          <div class="right-wapper">
            <div class="teacher-wrapper">
              <img src="../assets/images/teacher/zhangyunqi.png"/>
            </div>
            <div class="teacher-text">
              <h3>张云起</h3>
              <p>博士生导师</p>
              <p>中央财经大学商学院教授</p>
            </div>
          </div>
          <div style="clear: both;"></div>
          <div class="right-wapper">
            <div class="teacher-wrapper">
              <img src="../assets/images/teacher/kongfanchang.png"/>
            </div>
            <div class="teacher-text">
              <h3>孔繁昌</h3>
              <p>西南大学心理学部教育学博士，现任华中</p>
              <p>师范大学心理学副教授，硕士研究生导师</p>
            </div>
          </div>
          <div style="clear: both;"></div>
          <div class="right-wapper">
            <div class="teacher-wrapper">
              <img src="../assets/images/teacher/mengliang.png"/>
            </div>
            <div class="teacher-text">
              <h3>孟亮</h3>
              <p>上海外国语大学副教授、博士生导师</p>
            </div>
          </div>
          <div style="clear: both;"></div>
          <div class="right-wapper">
            <div class="teacher-wrapper">
              <img src="../assets/images/teacher/tianyouyi.png"/>
            </div>
            <div class="teacher-text">
              <h3>田友谊</h3>
              <p>海纳易学特聘讲师
              <p>
              <p>现任华中师范大学教育学院教授、博士生导师、教育学系主任、公共教育学教研室主任，兼任中国教育学会中青年教育理论工作者分会常务理事</p>
            </div>
          </div>
          <div style="clear: both;"></div>
          <div class="right-wapper">
            <div class="teacher-wrapper">
              <img src="../assets/images/teacher/luchun.png"/>
            </div>
            <div class="teacher-text">
              <h3>卢春</h3>
              <p>华中师范大学副教授</p>
            </div>
          </div>
          <div style="clear: both;"></div>
          <div class="right-wapper">
            <div class="teacher-wrapper">
              <img src="../assets/images/teacher/chandan.png"/>
            </div>
            <div class="teacher-text">
              <h3>陈丹</h3>
              <p>海纳易学特聘讲师</p>
              <p>武汉大学计算机学院教授、博士生导师</p>
            </div>
          </div>
          <div style="clear: both;"></div>
          <div class="right-wapper">
            <div class="teacher-wrapper">
              <img src="../assets/images/teacher/tanchunhui.png"/>
            </div>
            <div class="teacher-text">
              <h3>谭春辉</h3>
              <p>电子商务、网络营销顾问，湖北省电子商务研究中心副主任</p>
              <p>华中师范大学信息管理学院电子商务专业的教授、博士生导师</p>
            </div>
          </div>
          <div style="clear: both;"></div>
          <div class="right-wapper">
            <div class="teacher-wrapper">
              <img src="../assets/images/teacher/chanbin.png"/>
            </div>
            <div class="teacher-text">
              <h3>陈彬</h3>
              <p>管理学博士</p>
              <p>华中师范大学教育学院教授</p>
              <p>博士生导师</p>
            </div>
          </div>
          <div style="clear: both;"></div>
          <div class="right-wapper">
            <div class="teacher-wrapper">
              <img src="../assets/images/teacher/guoqingyang.png"/>
            </div>
            <div class="teacher-text">
              <h3>郭清扬</h3>
              <p>海纳易学特聘讲师</p>
              <p>华中师范大学教育学博士</p>
            </div>
          </div>
          <div style="clear: both;"></div>
          <div class="right-wapper">
            <div class="teacher-wrapper">
              <img src="../assets/images/teacher/wangtai.png"/>
            </div>
            <div class="teacher-text">
              <h3>王泰</h3>
              <p>华中师范大学国家数字化学习工程技术研究中心执教</p>
              <p>华中科技大学信息与通信工程博士</p>
            </div>
          </div>
          <div style="clear: both;"></div>
          <div class="right-wapper">
            <div class="teacher-wrapper">
              <img src="../assets/images/teacher/lengbojun.png"/>
            </div>
            <div class="teacher-text">
              <h3>冷柏军</h3>
              <p>对外经济贸易大学信息学院--院长</p>
              <p>对外经济贸易大学国际商务研究中心--执行主任</p>
            </div>
          </div>
          <div style="clear: both;"></div>
          <div class="right-wapper">
            <div class="teacher-wrapper">
              <img src="../assets/images/teacher/liuhuapeng.png"/>
            </div>
            <div class="teacher-text">
              <h3>刘华鹏</h3>
              <p>北京中科汇联（准科创板）</p>
              <p>AI学员执行院长</p>
              <p>国家工信部认证的人工智能应用高级工程师</p>
            </div>
          </div>
          <div style="clear: both;"></div>
          <div class="right-wapper">
            <div class="teacher-wrapper">
              <img src="../assets/images/teacher/zhangshaungli.png"/>
            </div>
            <div class="teacher-text">
              <h3>张双利</h3>
              <p>曾任职太空智造股份有限公司、东易日盛家居装饰集团股份有限公司、装配式建筑与装饰企业相关负责人，现任多家装配式建筑材料企业技术与商务顾问</p>
            </div>
          </div>
          <div style="clear: both;"></div>
          <div class="right-wapper">
            <div class="teacher-wrapper">
              <img src="../assets/images/teacher/zhaojian.png"/>
            </div>
            <div class="teacher-text">
              <h3>赵剑</h3>
              <p>海纳易学特聘讲师</p>
            </div>
          </div>
          <div style="clear: both;"></div>
          <div class="right-wapper">
            <div class="teacher-wrapper">
              <img src="../assets/images/teacher/liupingan.png"/>
            </div>
            <div class="teacher-text">
              <h3>刘平安</h3>
              <p>中国社会科学院经济学博士（金融方向）</p>
              <p>北京金长传资本管理有限公司董事长</p>
              <p>湖北汇澄茶油股份有限公司独立董事</p>
            </div>
          </div>
          <div style="clear: both;"></div>
          <div class="right-wapper">
            <div class="teacher-wrapper">
              <img src="../assets/images/teacher/fg.jpeg"/>
            </div>
            <div class="teacher-text">
              <h3>冯耘</h3>
              <p>中国心融集团董事长</p>
              <p>美国德州理工大学教育学院客座教授</p>
              <p>法国布雷斯特高等商学院教授</p>
              <p>德瑞姆应用心理学院院长</p>
              <p>美国心理咨询师协会(ACA)亚洲中心负责人</p>
            </div>
          </div>
        </mt-tab-container-item>
      </mt-tab-container>
    </div>
    <!-- 版权 -->
    <home-footer></home-footer>
  </div>
</template>
<script>
import HomeHeader from "@/components/homeHeader";
import HomeFooter from "@/components/homeFooter";
// import { Navbar, TabItem } from "mint-ui";
export default {
  name: "TeacherTroop",
  components: {
    HomeHeader,
    HomeFooter
  },
  data() {
    return {
      selected: "2"
    };
  },
  methods: {},
  mounted() {
  }
};
</script>
<style scoped>
/* banner */
.banner-info {
  width: 100%;
  height: 200px;
  background: url('../assets/images/banner002.png');
  background-size: 100% 100%;
}

.menu {
  width: 95%;
  margin: 0 auto;
  padding-top: 30px;
  margin-bottom: 50px;
}

/*tab切换样式 */
.mint-navbar {
  width: 100%;
  height: 60px;
}

.mint-navbar .mint-tab-item {
  border: 2px solid #E58111;
  width: 348px;
  height: 60px;
  color: #E58111;
}

.mint-navbar .mint-tab-item.is-selected {
  background: #E58111;
  font-size: 24px;
  color: #fff;
}

>>> .mint-tab-item-label {
  font-size: 26px;
}

/* 教师简介*/
.right-wapper {
  width: 100%;
  margin-top: 30px;
  height: auto;
}

.teacher-wrapper {
  width: 191px;
  height: 258px;
  float: left;
}

.teacher-wrapper img {
  width: 191px;
  height: 258px;
  object-fit: cover;
}

.teacher-text {
  width: 70%;
  float: right;
  /*height: 258px;*/
}

.teacher-text h3 {
  margin-top: 10px;
  font-size: 30px;
  color: #020202;
  padding-bottom: 10px;
}

.teacher-text p {
  font-size: 24px;
  font-weight: 400;
  color: rgba(2, 2, 2, 1);
  line-height: 38px;
}
</style>



// WEBPACK FOOTER //
// src/pages/teacherTroop.vue